import { Image } from "antd";
import { useTranslation } from "react-i18next";
import { useMobile } from "../../../../context/MobileContext";
import tree from "../../images/tree.png";
import styles from "./style.module.scss";

const AboutArea = () => {
  const { t } = useTranslation();
  const { isMobile } = useMobile();

  const sectionEnum = [
    {
      title: "about.aboutArea.title1",
      content: "about.aboutArea.content1",
      customTitle: styles.mainTitle,
    },
    { title: "about.aboutArea.title2", content: "about.aboutArea.content2", customTitle: "" },
    { title: "about.aboutArea.title3", content: "about.aboutArea.content3", customTitle: "" },
  ];

  return (
    <div className={styles.aboutArea}>
      <div className={styles.top}>
        <Image src={tree} alt="tree" preview={false} className={styles.img} />
      </div>
      <div className={styles.left}>
        {sectionEnum.map((item, index) => {
          return (
            <section key={index} className={styles.section}>
              <div className={`${styles.title} ${item.customTitle}`}>{t(item.title)}</div>
              <div className={styles.content}>{t(item.content)}</div>
            </section>
          );
        })}
      </div>
      <div className={styles.right}>
        <Image src={tree} alt="tree" preview={false} className={styles.img} />
      </div>
    </div>
  );
};

export default AboutArea;
